{
  "label_empty": "No data",
  "label-actions": "Actions",
  "label-row-select": "Select"
}
